import { logger } from "@hopper-b2b/api";

export type TapLogFn = (
  level: "info" | "warn",
  message: string,
  meta: Record<string, unknown>
) => void;

export const tapHandlerLog: TapLogFn = (level, message, meta) => {
  logger()?.[level](message, meta);
};
